import React, { useState, useEffect, useRef, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";

const testimonials = [
  {
    id: 1,
    name: "بـروش (1)",
    role: "Brooch",
    rating: 4,
    text: "A truly professional and rejuvenating experience. The staff is courteous and the ambiance is perfect for relaxation.",
    image_url: "https://imgg.io/images/2025/12/14/7566547c3ace81d7d367ddcafaaa65f8.jpg"
  },
  {
    id: 2,
    name: "بـروش (2)",
    role: "Brooch",
    rating: 5,
    text: "SERENITY has completely transformed my beauty routine. Every visit feels luxurious and refreshing.",
    image_url: "https://imgg.io/images/2025/12/14/7b24898f363a49f521107dbadc782a36.jpg"
  },
  {
    id: 3,
    name: "اقـلام",
    role: "Pens",
    rating: 4,
    text: "The attention to detail and professionalism here is unmatched. Truly a premium experience.",
    image_url: "https://imgg.io/images/2025/12/14/44012ce066d554354a4ba4eb208fae52.jpg"
  },
  {
    id: 4,
    name: "كيس ورقي",
    role: "Paper Bag",
    rating: 5,
    text: "Luxury ambiance, expert staff, and outstanding treatments. Highly recommended.",
    image_url: "https://imgg.io/images/2025/12/14/516ccf7210fcf5297d23abb44c0b65e8.jpg"
  },
  {
    id: 5,
    name: "قبـعـة",
    role: "Cap",
    rating: 4,
    text: "High standards, premium equipment, and excellent care. I always leave feeling renewed.",
    image_url: "https://imgg.io/images/2025/12/14/c34f8e21a06f13dc11c5ed5922a2435f.jpg"
  },
  {
    id: 6,
    name: "بـطاقة",
    role: "Card",
    rating: 5,
    text: "World-class service and results you can feel instantly. My go-to wellness destination.",
    image_url: "https://imgg.io/images/2025/12/14/5aac409be6ac5b7e7a33502cac635c8d.jpg"
  },
  {
    id: 7,
    name: "أعــلام",
    role: "Flags",
    rating: 4,
    text: "A calm, elegant space with professional therapists who truly understand wellness.",
    image_url: "https://imgg.io/images/2025/12/14/00817a8f31a6655feff475267f20b6f6.jpg"
  },
  {
    id: 8,
    name: "أكـواب",
    role: "Cups",
    rating: 5,
    text: "Absolutely loved the experience. The service, the vibe, everything feels premium.",
    image_url: "https://imgg.io/images/2025/12/14/10096021502973c1d6b35d6602006b37.png"
  },
  {
    id: 9,
    name: "تيشيـرت بـولـو",
    role: "Polo Shirt",
    rating: 4,
    text: "Professional service with noticeable results. Perfect place to unwind and recharge.",
    image_url: "https://imgg.io/images/2025/12/14/6c7a5b7644a0cb38af344f5e1cb1e9f3.jpg"
  }
];

export default function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageError, setImageError] = useState({});
  const intervalRef = useRef(null);

  const logos = useMemo(() => {
    return Array.from({ length: 8 }).map((_, i) => ({
      id: i,
      top: `${Math.random() * 80}%`,
      left: `${Math.random() * 80}%`
    }));
  }, []);

  const startSlideshow = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 2000);
  };

  const resetSlideshow = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    startSlideshow();
  };

  useEffect(() => {
    startSlideshow();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    resetSlideshow();
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    resetSlideshow();
  };

  const goToTestimonial = (index) => {
    setCurrentIndex(index);
    resetSlideshow();
  };

  const handleImageError = (testimonialId) => {
    setImageError((prev) => ({ ...prev, [testimonialId]: true }));
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section
      className="py-12 relative overflow-hidden border-b-4 border-white bg-[#ee9805]/5"
      onMouseEnter={() => clearInterval(intervalRef.current)}
      onMouseLeave={startSlideshow}
    >
      {/* اللوقوهات العشوائية ثابتة */}
      {logos.map((logo) => (
        <img
          key={logo.id}
          src="/logoW.png"
          alt="ZAN Logo"
          className="absolute opacity-40 w-20 h-20 object-contain"
          style={{ top: logo.top, left: logo.left }}
        />
      ))}

      <div className="relative max-w-4xl mx-auto px-6">
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
            className="relative"
          >
            <h2 className="font-cairo text-3xl lg:text-5xl font-bold text-[#141d3c] mb-8 relative z-10">
              مـاذا نقـدم ؟
            </h2>

            <AnimatePresence mode="wait">
              <motion.div
                key={currentTestimonial.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
                className="space-y-6"
              >
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                  {testimonials.slice(currentIndex, currentIndex + 3).map((testimonial) => (
                    <div key={testimonial.id} className="flex flex-col items-center">
                      <div className="w-40 h-40 rounded-2xl overflow-hidden shadow-lg border-4 border-white bg-gray-200 mb-4">
                        {imageError[testimonial.id] ? (
                          <div className="w-full h-full bg-gradient-to-br from-[#141d3c] to-[#ee9805] flex items-center justify-center">
                            <span className="text-white font-bold text-2xl">
                              {testimonial.name.split(' ').map(n => n[0]).join('')}
                            </span>
                          </div>
                        ) : (
                          <img
                            src={testimonial.image_url}
                            alt={`${testimonial.name}, a happy client`}
                            className="w-full h-full object-cover"
                            onError={() => handleImageError(testimonial.id)}
                          />
                        )}
                      </div>

                      {/* ⭐ التقييم تحت الصورة */}
                      <div className="flex items-center gap-1 mb-1">
                        {[...Array(5)].map((_, i) => (
                          <Star
                            key={i}
                            className={`w-4 h-4 ${
                              i < testimonial.rating
                                ? "fill-[#ee9805] text-[#ee9805]"
                                : "text-gray-300"
                            }`}
                          />
                        ))}
                        <span className="ml-1 text-xs font-semibold text-[#141d3c]">
                          {testimonial.rating}/5
                        </span>
                      </div>

                      <h4 className="font-cairo text-xl font-semibold text-[#141d3c]">
                        {testimonial.name}
                      </h4>
                      <p className="font-sans text-sm text-gray-500 uppercase tracking-wider">
                        {testimonial.role}
                      </p>
                    </div>
                  ))}
                </div>
              </motion.div>
            </AnimatePresence>

            {/* Navigation */}
            <div className="flex items-center justify-center gap-8 mt-8">
              <div className="flex items-center gap-4">
                <button
                  onClick={prevTestimonial}
                  className="w-10 h-10 bg-white border border-gray-200 rounded-full flex items-center justify-center text-gray-600 hover:bg-[#141d3c] hover:text-white transition-all duration-300"
                >
                  <ChevronLeft className="w-4 h-4" />
                </button>
                <button
                  onClick={nextTestimonial}
                  className="w-10 h-10 bg-white border border-gray-200 rounded-full flex items-center justify-center text-gray-600 hover:bg-[#141d3c] hover:text-white transition-all duration-300"
                >
                  <ChevronRight className="w-4 h-4" />
                </button>
              </div>

              {/* Dots Indicator */}
              <div className="flex gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToTestimonial(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 ${
                      index === currentIndex
                        ? 'bg-[#141d3c] w-6'
                        : 'bg-gray-300 hover:bg-gray-400'
                    }`}
                  />
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
